import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const DomainCountPage = lazy(() => import('./DomainCountPage'));

const path = 'reports/domain-count/count';
const DomainCountRoute: FuseRouteItemType = {
	path: path,
	element: <DomainCountPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Domain Count',
					helpName: 'Domain Count',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default DomainCountRoute;
